import { Search, X } from "lucide-react";
import { Button } from "../ui/button";

export const NO_FILTERS = { q: "", status: "", from: "", to: "" };
const STATUSES = [
  ["", "All ducks"],
  ["ready", "Print-ready"],
  ["building", "Building"],
  ["ordered", "Ordered"],
  ["attention", "Needs attention"],
];
const field = "h-11 rounded-full border border-border bg-card px-4 text-sm outline-none focus:ring-2 ring-accent/40";

// Name search, status and created-between filters; every flock section shows only the ducks that match.
export const DuckFilters = ({ value, onChange, searchOnly = false }) => {
  const set = (k) => (e) => onChange({ ...value, [k]: e.target.value });
  const active = value.q || (!searchOnly && (value.status || value.from || value.to));
  return (
    <div data-testid="your-ducks-filters" className="flex flex-wrap items-center gap-2">
      <div className="relative flex-1 min-w-[220px]">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <input
          data-testid="your-ducks-search-input"
          aria-label="Search ducks by name (Esc clears)"
          value={value.q}
          onChange={set("q")}
          onKeyDown={(e) => e.key === "Escape" && value.q && onChange({ ...value, q: "" })}
          placeholder="Search ducks by name…"
          className={`${field} w-full pl-9`}
        />
      </div>
      {!searchOnly && (
        <>
          <select data-testid="your-ducks-status-filter" aria-label="Status" value={value.status} onChange={set("status")} className={field}>
            {STATUSES.map(([v, label]) => (
              <option key={v} value={v}>{label}</option>
            ))}
          </select>
          <label className="flex items-center gap-1.5 text-[11px] font-mono2 uppercase tracking-widest text-muted-foreground">
            From
            <input type="date" data-testid="your-ducks-from" value={value.from} max={value.to || undefined} onChange={set("from")} className={`${field} px-3`} />
          </label>
          <label className="flex items-center gap-1.5 text-[11px] font-mono2 uppercase tracking-widest text-muted-foreground">
            To
            <input type="date" data-testid="your-ducks-to" value={value.to} min={value.from || undefined} onChange={set("to")} className={`${field} px-3`} />
          </label>
        </>
      )}
      {active && (
        <Button variant="ghost" data-testid="your-ducks-clear-filters" className="rounded-full gap-1" onClick={() => onChange(NO_FILTERS)}>
          <X className="h-4 w-4" /> Clear
        </Button>
      )}
    </div>
  );
};
